import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreService } from '../../../services/core.service';

declare const FB: any;

@Component({
  selector: 'app-facebook-token-page',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './facebook-token-page.component.html',
  styleUrl: './facebook-token-page.component.scss'
})
export class FacebookTokenPageComponent implements OnInit {

  constructor(
    private readonly coreService: CoreService,
  ) { }

  userToken: string | null = null;
  pages: any[] = [];
  loading = false;
  error: string | null = null;
  longUserToken: string | null = null;

  ngOnInit(): void {
    console.log('[FB] Component init');
    this.waitForFacebookSDK();
  }

  /* ---------------------------------------------------
   * SDK INIT
   * --------------------------------------------------- */
  private waitForFacebookSDK() {
    const interval = setInterval(() => {
      if (typeof FB !== 'undefined') {
        clearInterval(interval);
        this.initFacebook();
      }
    }, 100);
  }

  private initFacebook() {
    FB.init({
      appId: '812333361158803',
      cookie: true,
      xfbml: false,
      version: 'v24.0'
    });

    console.log('[FB] SDK initialized');
  }

  /* ---------------------------------------------------
   * LOGIN (CRITICAL PART)
   * --------------------------------------------------- */
  connectFacebook() {
    this.loading = true;
    this.error = null;

    FB.login(
      (response: any) => {
        console.log('[FB] Login response:', response);

        if (!response.authResponse) {
          this.loading = false;
          this.error = 'Facebook login cancelled';
          return;
        }

        this.userToken = response.authResponse.accessToken;
        console.log('[FB] User token:', this.userToken);

        // this.exchangeToken();
      },
      {
        scope: [
          'pages_show_list',
          'pages_read_engagement',
          'pages_manage_posts',
          'pages_manage_metadata',
          'instagram_basic',
          'business_management'
        ].join(','),

        auth_type: 'rerequest',
        return_scopes: true
      }
    );
  }

  /* ---------------------------------------------------
   * FETCH ALL PAGES (PERSONAL + BUSINESS)
   * --------------------------------------------------- */
  private fetchAllPages() {
    console.log('[FB] Fetching ALL pages…');
    this.pages = [];

    const personalPages: any[] = [];
    const businessPages: any[] = [];

    // Personal pages
    this.fetchAllWithPaging(
      '/me/accounts?fields=id,name,access_token,tasks&limit=100',
      personalPages,
      () => {
        console.log('[FB] Personal pages:', personalPages.length);

        // 2️⃣ Businesses
        FB.api('/me/businesses', (bizRes: any) => {
          if (!bizRes || bizRes.error || !bizRes.data?.length) {
            this.finalizePages(personalPages, []);
            return;
          }

          const businesses = bizRes.data;
          let pending = businesses.length * 2;

          const done = () => {
            pending--;
            if (pending === 0) {
              this.finalizePages(personalPages, businessPages);
            }
          };

          businesses.forEach((biz: any) => {
            // owned pages
            this.fetchAllWithPaging(
              `/${biz.id}/owned_pages?fields=id,name,access_token,tasks&limit=100`,
              businessPages,
              done
            );

            // client / partner pages 
            this.fetchAllWithPaging(
              `/${biz.id}/client_pages?fields=id,name,access_token,tasks&limit=100`,
              businessPages,
              done
            );
          });
        });
      }
    );
  }

  // exchangeToken() {

  //   this.coreService.postDataStage('facebook/exchange', {
  //     short_token: this.userToken
  //   }).subscribe((res: any) => {

  //     this.longUserToken = res.access_token;

  //     console.log('LONG USER TOKEN:', this.longUserToken);

  //     this.fetchAllPagesWithLongToken();

  //   }, err => {
  //     console.error('Exchange failed', err);
  //   });

  // }

  async upgradePageToken(page: any): Promise<void> {

    try {

      const res = await fetch(
        `https://graph.facebook.com/v24.0/${page.id}?fields=access_token&access_token=${this.longUserToken}`
      );

      const data = await res.json();

      if (data.access_token) {
        page.access_token = data.access_token;
        console.log('[UPGRADED] Page token for', page.id);
      } else {
        console.warn('[UPGRADE FAILED]', page.id, data);
      }

    } catch (err) {
      console.warn('[UPGRADE ERROR]', page.id, err);
    }
  }


  async fetchAllPagesWithLongToken() {

    const res = await fetch(
      `https://graph.facebook.com/v24.0/me/accounts?fields=id,name,access_token&access_token=${this.longUserToken}`
    );

    const data = await res.json();

    console.log('LONG PAGE TOKENS:', data);

    this.pages = data.data || [];
    this.loading = false;

    for (const page of this.pages) {

      console.log('----------------');
      console.log('Page:', page.name);
      console.log('Page ID:', page.id);

      console.log('UPGRADED PAGE TOKEN:', page.access_token);

      // 🔥 STEP 2 — IG lookup with upgraded token
      await this.fetchInstagramBusinessAccountDirect(page);
    }
  }




  /* ---------------------------------------------------
   * PAGINATION HELPER
   * --------------------------------------------------- */
  private fetchAllWithPaging(
    path: string,
    accumulator: any[],
    done: () => void
  ) {
    FB.api(path, (res: any) => {
      if (!res || res.error) {
        console.warn('[FB] Skipping edge (no permission)');
        done();
        return;
      }

      accumulator.push(...(res.data || []));

      if (res.paging?.next) {
        this.fetchAllWithPaging(res.paging.next, accumulator, done);
      } else {
        done();
      }
    });
  }

  /* ---------------------------------------------------
   * MERGE + DEDUPE
   * --------------------------------------------------- */
  private finalizePages(personal: any[], business: any[]) {
    const map = new Map<string, any>();

    [...personal, ...business].forEach(p => {
      if (!map.has(p.id)) {
        map.set(p.id, p);
      }
    });

    this.pages = Array.from(map.values());
    this.loading = false;

    console.log('[FB] ALL pages:', this.pages.length);

    // 👉 Log user token per page
    this.pages.forEach(page => {
      console.log('------------------------');
      console.log('Page:', page.name);
      console.log('Page ID:', page.id);
      console.log('USER TOKEN:', this.userToken);
      console.log('PAGE TOKEN:', page.access_token);
    });

    // IG fetch
    this.pages.forEach(page => {
      this.fetchInstagramBusinessAccountDirect(page);
    });
  }


  /* ---------------------------------------------------
   * IG BUSINESS
   * --------------------------------------------------- */
  async fetchInstagramBusinessAccountDirect(page: any): Promise<void> {

    if (!page.access_token) return;

    page.loadingIg = true;

    try {

      const res = await fetch(
        `https://graph.facebook.com/v24.0/${page.id}?fields=connected_instagram_account&access_token=${page.access_token}`
      );

      const data = await res.json();

      page.instagram_business_account =
        data?.connected_instagram_account?.id ?? null;

      console.log(
        '[IG]',
        page.id,
        '→',
        page.instagram_business_account?.id ?? null
      );

    } catch (err) {
      console.warn('[IG LOOKUP FAILED]', page.id, err);
    }

    page.loadingIg = false;
  }



}
